import "./WaterAndWastewater.module.css";
import Header from "@/reusable_sections/Header";
import PageHeader from "./sections/PageHeader";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import TheTreatmentPlantEnvironmentProblem from "./sections/TheTreatmentPlantEnvironmentProblem";
import WhatGetsLabeledInATreatmentPlant from "./sections/WhatGetsLabeledInATreatmentPlant";
import BuiltForWashDownChemicalExposure from "./sections/BuiltForWashDownChemicalExposure";
import PipeMarkingPlantSchemes from "./sections/PipeMarkingPlantSchemes";
import HowToOrder from "./sections/HowToOrder";
import WaterWastewaterLabelingCommonQuestions from "./sections/WaterWastewaterLabelingCommonQuestions";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function WaterAndWastewaterPage() {
  return <div>
      <Header />
      <PageHeader />
      <DirectAnswerBlock />
      <TheTreatmentPlantEnvironmentProblem />
      <WhatGetsLabeledInATreatmentPlant />
      <BuiltForWashDownChemicalExposure />
      <PipeMarkingPlantSchemes />
      <HowToOrder />
      <WaterWastewaterLabelingCommonQuestions />
      <ClosingCta />
      <Footer />
    </div>;
}